import { appConstant } from "@/app.constant";

export const globalSearchConstants = {
    SEARCH_PLACEHOLDER: 'Search YPO Connect',
    CANCEL: 'Cancel',
    VIEW: 'View',
    ALL_MATCHING_RESULTS: 'All Matching Results',
    OTHER_LABEL_IN: 'In',
    OTHER_LABEL_BEGINS_WITH: 'begins with...',
    WE_SEARCHED_IN: 'We searched in People, Events, Communities and Content',
    COULD_NOT_FIND: 'but could not find',
    BROWSE_ALL_PEOPLE: 'Browse All People',
    BROWSE_ALL_EVENTS: 'Browse All Events',
    BROWSE_ALL_COMMUNITIES: 'Browse All Communities',
    BROWSE_ALL_CONTENT: 'Browse All Content',
    UNABLE_TO_FIND: 'Still unable to find',
    CONTACT_US: 'Contact Us',
    ASK_YPO: 'ask@ypo.org',
    NO_MEMBER_RESULTS_AVAILABLE: 'No member results available',
    NO_EVENT_RESULTS_AVAILABLE: 'No event results available',
    NO_COMMUNITY_RESULTS_AVAILABLE: 'No community results available',
    NO_CONTENT_RESULTS_AVAILABLE: 'No content results available',
    ONE_CHARACTER_SEARCH_ERROR: 'We need a little more information. Please  enter more characters to continue your search.',
    NARROW_YOUR_SEARCH: 'NARROW YOUR SEARCH FOR',
    SEARCH_KEY: 'consolidatedSearch',
    WHO_CAN_ATTEND: 'Who Can Attend',
    MY_CHAPTER_EVENTS: 'My Chapter Events',
    MY_NETWORK_EVENTS: 'My Network Events',
    YPO_MANAGEMENT_ASSOCIATES: 'YPO Management',
    CFF: 'Certified Forum Facilitators',
    CHAPTER_ADMINISTRATORS: 'Chapter Administrators',
    CHAMPION_POSITIONS: 'Champion Positions',
    MY_NETWORKS: 'My Networks',
    CHAPTER_OFFICERS: 'Chapter Officers',
    MY_PRIMARY_CHAPTER: 'My Primary Chapter',
    PEOPLE: 'People',
    EVENT: 'Event',
    CONTENT: 'Content',
    VOUCHER: 'voucher',
    VOUCHERS: 'vouchers',
    COMMUNITY: 'Community',
    INTERSTITIAL_NO_RESULTS: 'No results',
    INTERSTITIAL_ONE_CHAR: 'One character',
    INTERSTITIAL_NARROW_SEARCH: 'Narrow search',
    TOP_MARGIN_CSS_REG_IPAD: `top: 86px !important`,
    TOP_MARGIN_CSS_SMALL_IPAD: `top: 150px !important`,
};

export const peopleTileConstants = {
    TITLE: 'FIND MEMBERS & MORE',
    FULL_MEMBER_DIRECTORY: 'Full Member Directory >>',
    FULL_MEMBER_DIRECTORY_NO_RESULTS: 'Full Member Directory',
    MANAGEMENT_ASSOCIATE: 'YPO Management Associate',
    CHAPTER_MANAGER: 'Chapter Manager',
    CHAPTER_ADMIN: 'Chapter Administrator',
    ADVANCED_SEARCH: 'Try Advanced Member Search',
    NEW: 'new', 
    ALL_MATCHES: 'ALL MATCHES',
    FIND_MATCHES_BY_NAME: "FIND MATCHES BY NAME",
    NO_RESULTS: "No results found. Please check your spelling or browse the Full Member Directory for other matches",    
    MEMBERDIRECTORY_SEARCH_PAGE: 'memberdirectory/?searchkey=', 
};

export const eventTileConstants = {
    TITLE: 'FIND EVENTS',
    FULL_EVENT_DIRECTORY: 'Full Event Directory',
    ACCEPTS_VOUCHER: 'AcceptsVoucher',
    VIRTUAL: 'Virtual',
    ATTRIBUTION_TRACKING: {
        trackingKey: "RefID",
        searchResultTileId: "CTSR",
        eventDirectoryTileId: "CTED",
        homeEventWidgetId: "CTHM",
        communityEventWidgetId: "CTCM",
    },
};

export const communityTileConstants = {
    GROUP: 'group',
    CHAPTER: 'chapter',
    NETWORK: 'network',
    REGION: 'region',
    TITLE: 'FIND COMMUNITIES',
    FULL_COMMUNITY_DIRECTORY: 'Full Community Directory',
};

export const contentTileConstants = {
    TITLE: 'FIND CONTENT',
    FULL_CONTENT_DIRECTORY: 'Full Content Directory',
};

export const constructSortFilters = (label) => {
    if (label === 'First Name') {
        return {
            label: 'Last Name',
            key: `LastName_asc`,
            sortField: 'LastName',
            direction: 'asc',
        };
    } else if (label === 'Last Name') {
        return {
            label: 'First Name',
            key: `FirstName_asc`,
            sortField: 'FirstName',
            direction: 'asc',
        };
    } else if (label === 'Company Name') {
        return {
            label: 'Company Name',
            key: `CompanyName_asc`,
            sortField: 'CompanyName',
            direction: 'asc',
        };
    }
};

export const facetLabel = (label, integratedSearchName, searchText) => {
   return integratedSearchName === 'begins with...' ?
        `${label}  begins with "${searchText}"` :
        `"${searchText}" in ${label}`;
};

export const eventVoucherObject = {
    name: "Events that accept vouchers",
    label: "Events that accept vouchers",
    filterKey: "AcceptsVoucher",
    filterValue: "True",
    isTypeAhead: false,
    isDropdown: false,
    subFilters: [],
    ribbonGroupName: "Vouchers",
};

export const eventNameBeginsPill = (searchText) => {
    return {
        label: `Event Name begins with "${searchText}"`,
        filterKey: "EventName>ConsolidatedSearch",
        filterValue: "",
        isTypeAhead: false,
        isDropdown: false,
        subFilters: [],
        count: 0,
        ribbonGroupName: "Event Name",
        name: "Event Name",
        integratedSearchName: "begins with...",
        key: "orderByEventName",
        fieldToQuery: "EventName",
    };
};

export const getAttributionTracking = (url, trackingId) => {
    let result = url;
    const attributionFromStorage = JSON.parse(sessionStorage.getItem(appConstant.storageKeys.ypoAttributionData));
    if (attributionFromStorage && attributionFromStorage.expiresAt && new Date(attributionFromStorage.expiresAt) > new Date()) {
        result = `${result}?${eventTileConstants.ATTRIBUTION_TRACKING.trackingKey}=${attributionFromStorage.refId}`;
    } else {
        result = `${result}?${eventTileConstants.ATTRIBUTION_TRACKING.trackingKey}=${trackingId}`;
    }
    return result;
};
